import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";

const CartContext = createContext();

export default function CartProvider({ children }) {
  const [items, setItems] = useLocalStorage("salat_cart", []);

  const addItem = (productId, quantity, maxQuantity = null) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.productId === productId);
      if (existing) {
        let nextQuantity = existing.quantity + quantity;
        if (maxQuantity != null) nextQuantity = Math.min(nextQuantity, maxQuantity);
        return prev.map((i) =>
          i.productId === productId ? { ...i, quantity: nextQuantity } : i
        );
      }
      const initialQuantity = maxQuantity != null ? Math.min(quantity, maxQuantity) : quantity;
      return [...prev, { productId, quantity: initialQuantity }];
    });
  };

  const updateQuantity = (productId, quantity, maxQuantity = null) => {
    setItems((prev) =>
      prev.map((i) =>
        i.productId === productId
          ? { ...i, quantity: maxQuantity != null ? Math.min(quantity, maxQuantity) : quantity }
          : i
      )
    );
  };

  const removeItem = (productId) => {
    setItems((prev) => prev.filter((i) => i.productId !== productId));
  };

  const clear = () => setItems([]);

  const itemCount = useMemo(
    () => items.reduce((sum, i) => sum + i.quantity, 0),
    [items]
  );

  const value = { items, itemCount, addItem, updateQuantity, removeItem, clear };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
